import { produce } from 'immer';
import { StateCreator } from 'zustand';

import { CompanyData, PublicProjectBody } from '@desygner/ui-data-access-projects';

import { IWorkspaceStore } from './workspace.store';

/**
 * This is the state of the Company slice.
 */
export interface CompanyState {
  data: CompanyData | null;
  isEnterprise: boolean;
  isWorkspace: boolean;
  publicData: PublicProjectBody['company'] | null;
}

/**
 * Actions related to the Company state.
 */
export interface CompanyActions {
  setCompanyData: (data: CompanyState['data']) => void;
  setCompanyPublicData: (data: CompanyState['publicData']) => void;
  setIsEnterprise: (isEnterprise: boolean) => void;
  setIsWorkspace: (isWorkspace: boolean) => void;
}

export type CompanySlice = {
  company: CompanyState & CompanyActions;
};

/**
 * Creates the Company slice. This function can be merged into
 * a larger store (e.g., a workspace store).
 */
export const createCompanySlice: StateCreator<IWorkspaceStore, [], [], CompanySlice> = (set) => ({
  company: {
    isWorkspace: false,
    isEnterprise: false,

    data: null,
    publicData: null,

    setCompanyPublicData: (data: CompanyState['publicData']) =>
      set(
        produce((draft: CompanySlice) => {
          draft.company.publicData = data;
        })
      ),

    setIsEnterprise: (isEnterprise: boolean) =>
      set(
        produce((draft: CompanySlice) => {
          draft.company.isEnterprise = isEnterprise;
        })
      ),

    setIsWorkspace: (isWorkspace: boolean) =>
      set(
        produce((draft: CompanySlice) => {
          draft.company.isWorkspace = isWorkspace;
        })
      ),

    setCompanyData: (data: CompanyState['data']) =>
      set(
        produce((draft: CompanySlice) => {
          draft.company.data = data;
        })
      ),
  },
});
